import React from "react";

import StudentCommunicationTipsContent from "../../../assets/images/CommunicationTips.png";
import def from "ajv/dist/vocabularies/discriminator";

const StudentCommunicationTipsModal  = () => {
return(
    <div>
        <img src={StudentCommunicationTipsContent} alt="Student Communication Tips" />

    </div>
);
};
export default StudentCommunicationTipsModal ;